import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AdjustmentTemplateDataSource, AdjustmentTemplateModel, AdjustmentTemplateState, LoadAdjustmentTemplates } from 'src/app/core/template';
import { PaginationEvent } from 'src/app/views/pages/template/template-list/template-list.component';

@Component({
  selector: 'kt-adjustment-template-list',
  templateUrl: './adjustment-template-list.component.html',
  styleUrls: ['./adjustment-template-list.component.scss']
})
export class AdjustmentTemplateListComponent implements OnInit {
  dataSource: AdjustmentTemplateDataSource;
  pageSize = 4;

  constructor(
    public dialogRef: MatDialogRef<AdjustmentTemplateListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AdjustmentTemplateState>
  ) { }

  ngOnInit(): void {
    this.dataSource = new AdjustmentTemplateDataSource(this.store);
    this.store.dispatch(new LoadAdjustmentTemplates({
      request: {
        pageNumber: 1,
        pageSize: this.pageSize,
        assetClassTypeID: this.data.assetClassTypeId
      }
    }));
  }

  loadList(event: PaginationEvent) {
    this.store.dispatch(new LoadAdjustmentTemplates({
      request: {
        pageNumber: event.pageNumber + 1,
        pageSize: event.pageSize
      }
    }));
  }

  selectTemplate(event: AdjustmentTemplateModel) {
    this.dialogRef.close({
      type: 'select',
      template: event
    });
  }

  viewTemplate(event: AdjustmentTemplateModel) {
    this.dialogRef.close({
      type: 'view',
      template: event
    })
  }

  onNoClick() {
    this.dialogRef.close();
  }
}
